import { ChipGroup, Field, SectionLabel, SelectField } from "@/components/ui";

export const PERSONAL_KEYS = [
  "gender", "nationality", "occupation", "education", "marital_status", "children", "preferred_language",
  "religion", "income_range", "bio", "relationship_expectations",
];

const one = (v) => (v ? [v] : []);
const Err = ({ children }) => (children ? <p className="mt-1.5 text-xs font-medium text-[#9E3C3E]">{children}</p> : null);

export function StepPersonal({ value, onChange, options, age, errors, openSelect }) {
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  const chips = (k, opts, prefix) => <ChipGroup testIdPrefix={prefix} multi={false} options={opts} value={one(value[k])} onChange={(v) => set(k)(v[0] ?? null)} />;
  return (
    <div data-testid="wizard-step-personal">
      <h1 className="text-[34px] leading-tight">About you</h1>
      <p className="mb-6 mt-1 text-sm text-muted-foreground">You are {age}. Tell members a little about who you are.</p>
      <SectionLabel>Gender</SectionLabel>
      {chips("gender", options.genders, "personal-gender")}<Err>{errors.gender}</Err>
      <div className="mt-5 grid gap-x-4 sm:grid-cols-2">
        <SelectField testId="personal-nationality-select" label="Nationality (optional)" value={value.nationality} placeholder="Select nationality" onClick={() => openSelect("nationality")} />
        <Field testId="personal-occupation-input" label="Occupation" value={value.occupation ?? ""} onChange={(e) => set("occupation")(e.target.value)} placeholder="e.g. Software Engineer" error={errors.occupation} />
      </div>
      <SectionLabel note="Optional">Education</SectionLabel>
      {chips("education", options.educations, "personal-education")}
      <div className="mt-5" />
      <SectionLabel>Marital status</SectionLabel>
      {chips("marital_status", options.marital_statuses, "personal-marital")}<Err>{errors.marital_status}</Err>
      <div className="mt-5" />
      <SelectField testId="personal-language-select" label="Preferred language" value={value.preferred_language} placeholder="Select language" onClick={() => openSelect("preferred_language")} error={errors.preferred_language} />
      <div className="my-5 rounded-[20px] border border-border bg-white p-5">
        <p className="font-display text-xl">Private details</p>
        <p className="mb-4 mt-1 text-xs text-muted-foreground">Religion, children and income are never shown publicly. They only help us find better matches.</p>
        <SectionLabel note="Optional">Children</SectionLabel>
        {chips("children", options.children, "personal-children")}
        <div className="mt-4" />
        <SectionLabel note="Optional">Religion</SectionLabel>
        {chips("religion", options.religions, "personal-religion")}
        <div className="mt-4" />
        <SectionLabel note="Optional">Income range</SectionLabel>
        {chips("income_range", options.income_ranges, "personal-income")}
      </div>
      <Field testId="personal-bio-input" label="Bio" multiline maxLength={600} value={value.bio ?? ""} onChange={(e) => set("bio")(e.target.value)} placeholder="What makes you, you?" error={errors.bio} />
      <Field testId="personal-expectations-input" label="Relationship expectations" multiline maxLength={600} value={value.relationship_expectations ?? ""} onChange={(e) => set("relationship_expectations")(e.target.value)} placeholder="What kind of relationship are you hoping for?" />
    </div>
  );
}
